(function() {
  var isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  if (!isTouch) return;

  var cards = document.querySelectorAll(".card-wrapper");
  cards.forEach(function(card) {
    var container = card.querySelector(".media--hover-effect");
    if (!container) return;
    var imgs = container.querySelectorAll("img");
    if (imgs.length < 2) return;

    // Tranzitie pe toate imaginile
    Array.from(imgs).forEach(function(img, i) {
      img.style.transition = "opacity 0.7s ease";
      img.style.opacity = i === 0 ? "1" : "0";
    });

    // Indicator dots
    var dotsEl = document.createElement("div");
    dotsEl.setAttribute("aria-hidden", "true");
    dotsEl.style.cssText = "position:absolute;bottom:8px;left:50%;transform:translateX(-50%);display:flex;gap:5px;z-index:3;pointer-events:none";

    var dots = [];
    for (var i = 0; i < imgs.length; i++) {
      var dot = document.createElement("span");
      dot.style.cssText = "width:5px;height:5px;border-radius:50%;background:" + (i === 0 ? "#fff" : "rgba(255,255,255,0.45)") + ";transition:background 0.3s;display:block";
      dotsEl.appendChild(dot);
      dots.push(dot);
    }
    container.appendChild(dotsEl);

    var current = 0;
    var timer = null;
    var INTERVAL = 3500;

    function show(idx) {
      if (idx === current) return;
      imgs[current].style.opacity = "0";
      imgs[idx].style.opacity = "1";
      dots[current].style.background = "rgba(255,255,255,0.45)";
      dots[idx].style.background = "#fff";
      current = idx;
    }

    function next() { show((current + 1) % imgs.length); }
    function prev() { show((current - 1 + imgs.length) % imgs.length); }

    function start() { if (!timer) timer = setInterval(next, INTERVAL); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    // Auto-rotate doar cand e vizibil
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) start(); else stop();
      });
    }, { threshold: 0.3 });
    obs.observe(card);

    // Swipe
    var startX = 0;
    container.addEventListener("touchstart", function(e) {
      startX = e.changedTouches[0].screenX;
    }, { passive: true });

    container.addEventListener("touchend", function(e) {
      var dx = e.changedTouches[0].screenX - startX;
      if (Math.abs(dx) < 30) return;
      if (dx < 0) next(); else prev();
      restart();
    }, { passive: true });
  });
})();